import React, { useState, useEffect } from 'react';
import axios from 'axios';
import API_BASE_URL from '../api';
import Swal from 'sweetalert2';

const AdminProfile = () => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const [passwords, setPasswords] = useState({ current: '', new: '', confirm: '' });
    const [config, setConfig] = useState({ passwordMinLength: 8 });

    // Security config is defaulted locally to min length 8

    const handlePasswordChange = async (e) => {
        e.preventDefault();
        if (passwords.new !== passwords.confirm) {
            Swal.fire('Error', 'New passwords do not match', 'error');
            return;
        }

        if (passwords.new.length < config.passwordMinLength) {
            Swal.fire('Validation Error', `Password must be at least ${config.passwordMinLength} characters as per security policy.`, 'warning');
            return;
        }

        try {
            const token = localStorage.getItem('token');
            await axios.put(`${API_BASE_URL}/api/users/profile/password`, {
                currentPassword: passwords.current,
                newPassword: passwords.new
            }, {
                headers: { Authorization: `Bearer ${token}` }
            });

            Swal.fire({
                title: 'Success',
                text: 'Credentials updated. For security, your current session will be terminated.',
                icon: 'success',
                confirmButtonColor: '#2C1A10'
            });

            localStorage.clear();
            setTimeout(() => window.location.href = '/', 2000);
        } catch (err) {
            Swal.fire('Error', err.response?.data?.error || 'Failed to update password', 'error');
        }
    };

    return (
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
            <div style={{ marginBottom: '40px' }}>
                <h1 style={{ margin: '0 0 8px 0', fontSize: '32px', fontWeight: '800', color: '#2C1A10' }}>Security Clearance & Identity</h1>
                <p style={{ margin: 0, color: '#999', fontSize: '16px' }}>Manage high-level administrative credentials and session integrity.</p>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: 'minmax(400px, 1fr) 450px', gap: '40px' }}>
                {/* Official Identity Card */}
                <div style={{ backgroundColor: '#fff', borderRadius: '24px', padding: '40px', boxShadow: '0 10px 30px rgba(0,0,0,0.02)', border: '1px solid #F0E8DB' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '25px', marginBottom: '40px' }}>
                        <div style={{
                            width: '80px',
                            height: '80px',
                            borderRadius: '24px',
                            backgroundColor: '#C0722C',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: '#fff',
                            fontSize: '32px',
                            fontWeight: '800',
                            boxShadow: '0 10px 20px rgba(192, 114, 44, 0.2)'
                        }}>
                            {user.name ? user.name[0] : 'G'}
                        </div>
                        <div>
                            <h2 style={{ margin: '0 0 5px 0', color: '#2C1A10', fontSize: '24px' }}>{user.name || 'Governor Office'}</h2>
                            <span style={{ backgroundColor: '#FDF8F3', color: '#C0722C', padding: '6px 12px', borderRadius: '8px', fontSize: '12px', fontWeight: '800', textTransform: 'uppercase', letterSpacing: '1px', border: '1px solid #C0722C20' }}>
                                LEVEL 4 CLEARANCE
                            </span>
                        </div>
                    </div>

                    <div style={{ display: 'grid', gap: '25px' }}>
                        <div style={{ borderBottom: '1px solid #F5F0E8', paddingBottom: '20px' }}>
                            <label style={{ display: 'block', fontSize: '11px', color: '#999', fontWeight: '800', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '8px' }}>IDENTITY ASSIGNMENT</label>
                            <div style={{ fontSize: '16px', fontWeight: '700', color: '#333' }}>{user.name || 'Governor Office'}</div>
                        </div>
                        <div style={{ borderBottom: '1px solid #F5F0E8', paddingBottom: '20px' }}>
                            <label style={{ display: 'block', fontSize: '11px', color: '#999', fontWeight: '800', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '8px' }}>OFFICIAL EMAIL VECTOR</label>
                            <div style={{ fontSize: '16px', fontWeight: '700', color: '#333' }}>{user.email || 'governor@vidhansabha.bih.nic.in'}</div>
                        </div>
                        <div style={{ paddingBottom: '10px' }}>
                            <label style={{ display: 'block', fontSize: '11px', color: '#999', fontWeight: '800', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '8px' }}>ADMINISTRATIVE DOMAIN</label>
                            <div style={{ fontSize: '16px', fontWeight: '700', color: '#333' }}>{user.role || 'SuperAdmin'} - Bihar Vidhan Sabha</div>
                        </div>
                    </div>

                    <div style={{ marginTop: '40px', padding: '25px', backgroundColor: '#2C1A10', borderRadius: '16px', border: '1px solid #C0722C40', position: 'relative', overflow: 'hidden' }}>
                        <div style={{ position: 'relative', zIndex: 1 }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
                                <div style={{ width: '8px', height: '8px', backgroundColor: '#4CAF50', borderRadius: '50%', boxShadow: '0 0 10px #4CAF50' }}></div>
                                <span style={{ fontSize: '13px', color: '#EAD7BB', fontWeight: '700' }}>Active Integrity Monitor</span>
                            </div>
                            <div style={{ fontSize: '12px', color: '#999', fontFamily: '"Roboto Mono", monospace' }}>
                                VECTOR: 192.168.1.1 // BROWSER: CHROME/EN-US
                            </div>
                        </div>
                    </div>
                </div>

                {/* Password Credential Shield */}
                <div style={{ backgroundColor: '#fff', borderRadius: '24px', padding: '40px', boxShadow: '0 10px 30px rgba(0,0,0,0.02)', border: '1px solid #F0E8DB' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '35px' }}>
                        <div style={{ color: '#C0722C' }}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>
                        </div>
                        <h3 style={{ margin: 0, color: '#2C1A10', fontSize: '20px', fontWeight: '800' }}>Credential Update</h3>
                    </div>

                    <form onSubmit={handlePasswordChange}>
                        <div style={{ marginBottom: '25px' }}>
                            <label style={{ display: 'block', fontSize: '12px', color: '#666', fontWeight: '700', marginBottom: '10px' }}>CURRENT PASSPHRASE</label>
                            <input
                                type="password"
                                className="custom-input"
                                value={passwords.current}
                                onChange={e => setPasswords({ ...passwords, current: e.target.value })}
                                required
                                style={{
                                    width: '100%',
                                    padding: '16px 20px',
                                    borderRadius: '12px',
                                    border: '1.5px solid #F0E8DB',
                                    backgroundColor: '#FAFAFA',
                                    fontSize: '15px'
                                }}
                            />
                        </div>
                        <div style={{ marginBottom: '25px' }}>
                            <label style={{ display: 'block', fontSize: '12px', color: '#666', fontWeight: '700', marginBottom: '10px' }}>NEW PASSPHRASE</label>
                            <input
                                type="password"
                                className="custom-input"
                                value={passwords.new}
                                onChange={e => setPasswords({ ...passwords, new: e.target.value })}
                                required
                                style={{
                                    width: '100%',
                                    padding: '16px 20px',
                                    borderRadius: '12px',
                                    border: '1.5px solid #F0E8DB',
                                    backgroundColor: '#FAFAFA',
                                    fontSize: '15px'
                                }}
                            />
                            <div style={{ fontSize: '11px', color: '#999', marginTop: '8px', fontWeight: '500' }}>
                                Policy: Minimum {config.passwordMinLength} characters required.
                            </div>
                        </div>
                        <div style={{ marginBottom: '35px' }}>
                            <label style={{ display: 'block', fontSize: '12px', color: '#666', fontWeight: '700', marginBottom: '10px' }}>RE-TYPE PASSPHRASE</label>
                            <input
                                type="password"
                                className="custom-input"
                                value={passwords.confirm}
                                onChange={e => setPasswords({ ...passwords, confirm: e.target.value })}
                                required
                                style={{
                                    width: '100%',
                                    padding: '16px 20px',
                                    borderRadius: '12px',
                                    border: '1.5px solid #F0E8DB',
                                    backgroundColor: '#FAFAFA',
                                    fontSize: '15px'
                                }}
                            />
                        </div>
                        <button
                            type="submit"
                            style={{
                                width: '100%',
                                padding: '18px',
                                backgroundColor: '#2C1A10',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '15px',
                                fontWeight: '700',
                                fontSize: '15px',
                                cursor: 'pointer',
                                boxShadow: '0 10px 20px rgba(44, 26, 16, 0.2)',
                                transition: 'all 0.3s ease'
                            }}
                            onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                            onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                        >
                            Authorize Update
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AdminProfile;
